/* ==========================================================================
   CRAFTD - Honu Bay refresh (Danny, 30 Aug 2026). Live on UK, EU and US.
   Pairs with assets/hb-refresh.css, loaded from snippets/scripts.liquid.

   Two jobs:
   1. Move the What's Included panel below the Add To Cart button on every
      product page. The panel (.cro-wi) is rendered by snippets/product-addons
      .liquid, which sits above the CTA in all three product sections
      (product-detail, product-detail-pendant, product-detail-builder) and in
      a different parent in each. Moving the node here keeps one behaviour
      across all three without editing any of those files. Alpine bindings
      survive the move because the node itself is preserved.
   2. Close the Sort By dropdown on collection pages. It is rendered open
      because it used to live in a sidebar column; the stylesheet now floats
      it top right, where open by default would cover the first row.

   Delivered as an asset rather than an inline block on purpose: inline
   script blocks were neutralised for some visitors in August.
   ========================================================================== */

(function () {
  var STICKY = '.product-sticky-bar, .cro-sticky-atc, .pv2-sticky, .shopify-section--cro-sticky-atc';

  function moveIncluded() {
    var panels = document.querySelectorAll('.cro-wi');

    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (panel.getAttribute('data-hb-moved') === '1') continue;

      var scope = panel.closest('.pv2-form') || document;
      var candidates = scope.querySelectorAll('.pv2-form__button-container, .pv2-form__button');
      var anchor = null;

      for (var j = 0; j < candidates.length; j++) {
        var el = candidates[j];
        if (el.closest(STICKY)) continue;   /* never the sticky bar's button */
        if (el === panel || panel.contains(el)) continue;
        anchor = el;
        break;
      }

      if (!anchor) continue;
      if (anchor.nextElementSibling === panel) {
        panel.setAttribute('data-hb-moved', '1');
        continue;
      }

      anchor.insertAdjacentElement('afterend', panel);
      panel.setAttribute('data-hb-moved', '1');
    }
  }

  function closeSort() {
    var sorts = document.querySelectorAll('details.gsx-sort--sidebar[open]');
    for (var i = 0; i < sorts.length; i++) {
      if (sorts[i].getAttribute('data-hb-closed') === '1') continue;
      sorts[i].open = false;
      sorts[i].setAttribute('data-hb-closed', '1');
    }
  }

  function run() {
    try { moveIncluded(); } catch (e) {}
    try { closeSort(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The buy box hydrates with Alpine after load, and a variant change can
     re-render parts of it, so run once more on load and keep a short watch. */
  window.addEventListener('load', run);
  if (window.MutationObserver) {
    var observer = new MutationObserver(run);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  }
})();
